<template lang="html">
  <div>
    <TextInput
      v-model="fileName" required
      name="fileName"
      :disabled="disableTextInput"
    >
      <template #label>
        <IxRes>Common.SR_Common.FileName</IxRes>
      </template>
    </TextInput>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {mapFormFields} from '@helpers/vuex'

import TextInput from '@components/forms/TextInput'

export default {
  components: {
    TextInput
  },
  computed: {
    ...mapFormFields('fieldRecordSystem/download', [
      'fileName'
    ]),
    ...mapState('fieldRecordSystem/download', {
      selectedConverter: state => state.selectedConverter
    }),
    disableTextInput () {
      if (this.selectedConverter === 'KmlConverter' || this.selectedConverter === 'TopConConverter') {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="css">
</style>
